// Brand logo assets uploaded by the client
export const LOGO_LIGHT = "https://customer-assets-jai6qajn.emergentagent.net/job_senior-poodle-cbd/artifacts/uepg89vu_IMG_2554.jpg"; // white background
export const LOGO_DARK = "https://customer-assets-jai6qajn.emergentagent.net/job_senior-poodle-cbd/artifacts/4nxjfx3m_IMG_4774.webp"; // black background

// Circular badge crop of the doodle (drops the arced wordmark, great as an avatar mark)
export const LogoBadge = ({ size = 44, className = "" }) => (
  <span
    className={`inline-block flex-none overflow-hidden rounded-full ring-1 ring-[#E6E0D4] ${className}`}
    style={{ width: size, height: size }}
  >
    <img
      src={LOGO_LIGHT}
      alt="CBDoodle"
      className="h-full w-full object-cover"
      style={{ objectPosition: "50% 62%", transform: "scale(1.55)" }}
    />
  </span>
);

// Full logo illustration (with wordmark). variant: 'light' (white bg) | 'dark' (black bg)
export const LogoFull = ({ variant = "light", className = "" }) => (
  <img
    src={variant === "dark" ? LOGO_DARK : LOGO_LIGHT}
    alt="CBDoodle logo"
    className={className}
    loading="lazy"
  />
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-serif text-[22px] font-semibold tracking-tight text-[#2C2B29] ${className}`}>
    CBD<span className="text-[#4A6B5D]">oodle</span>
  </span>
);
